import { AbstractContentState, useCmsContent } from '@cp-shared-15/frontend-integration';
import { IconFooter } from 'cpie-common';
import { fetchIconFooter } from './IconFooterSlice';
import { IconFooterContentSelector } from './IconFooterContentSelector';

export function useIconFooter(): AbstractContentState<IconFooter> {
    return useCmsContent(fetchIconFooter, IconFooterContentSelector);
}
